
<div class="relative w-full">
    <div class="absolute top-1/4 left-28 text-white space-y-5">
        <p class="text-5xl font-thin">Effective Annual Cost</p>
        <p class="font-light">The Effective Annual Cost calculator helps you calculate your investment charges and the <br> impact these have on your investment.</p>
    </div>
    <img class="h-80 w-full object-center lg:h-80 bg-gray-900" src="../../../assets/images/eac-banner.png" alt=""> 
</div>
<div class="px-28 my-10">
    <div class="font-semibold mb-2">{{headerText}}</div>
    <p *ngIf="showDescription" class="font-extralight text-sm text-gray-900 mb-6">The Effective Annual Cost measure (EAC) is a standardized disclosure methodology that can be used by consumers and financial advisers to compare charges and their impact on investment returns on most retail investment products so that consumers are placed in a position to make better informed decisions. In our instance this is in respect of the costs of investing in a Collective Investment Scheme portfolio (unit trust fund).</p>
    <div class="w-full border-t border-orange-forbes"></div> 
</div>
 